import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const financingBrokerageSubventionServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const financingBrokerageSubventionServiceConfigDtoSchema = serviceConfigSchema;

export { financingBrokerageSubventionServiceConfigDtoSchema, financingBrokerageSubventionServiceConfigSchema };
//# sourceMappingURL=FinancingBrokerageSubventionServiceConfig.js.map
